import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Text from '../../../../units/Text/Text';
import Button from '../../../../units/Button/Button';
import Icon from '../../../../units/Icon/Icon';

import FormInput from '../../FormControls/FormInput/FormInput';

import { FormTitle } from '../../FormUnits/FormUnits';

import FormDropdown from '../../FormControls/FormDropdown/FormDropdown';

import withForm from '../../../../hocs/withForm';

const InputWrapper = styled(Box).attrs({
  mb: '20px'
})``;

const FieldLabel = styled(Box).attrs({
  mr: '20px'
})`
  position: absolute;
  right: 100%;
  top: ${props => props.top || '0px'};
`;

const LoginWrapper = styled(Flex).attrs({})`
  position: relative;
`;

const FieldLabelText = styled(Text).attrs({
  font: 'caption',
  size: '13px',
  color: '#555555'
})``;

const LoginValueBox = styled(Box)`
  max-width: 400px;
`;

const LoginValue = styled(Text).attrs({
  size: '18px',
  color: '#555555'
})``;

const PasswordFirstWrapper = Flex.extend`
  position: relative;
`;

const PasswordDemandsWrapper = Box.extend`
  position: absolute;
  color: ${props => props.theme.colors.link};
  left: 421px;
  top: 10px;
  white-space: nowrap;
`;

const ChooseRegionTitleWrapper = styled(Box).attrs({
  mb: '10px'
})`
  text-transform: uppercase;
`;

const ChooseRegionWrapper = styled(Box).attrs({
  w: '100%',
  mb: '30px'
})`
  position: relative;
`;

const ChooseRegionBackground = styled(Icon).attrs({
  icon: 'country',
  width: '513px',
  height: '259px'
})`
  position: absolute;
  left: -76px;
  top: -18px;
  z-index: -1;
`;

const NotTransparentBackgroundWrapper = styled(Box)`
  background-color: ${props => props.theme.colors.white};
`;

const PasswordForm = ({
  getFieldProps,
  fields,
  getActionProps,
  handleSubmit,
  applyAction
}) => {
  const saveForm = values => {
    applyAction({
      actionId: 'next',
      values
    });
  };

  const showHint = () => {
    applyAction({
      actionId: 'passwordHint'
    });
  };

  return (
    <Flex column justify="center" align="center" className="zeroClient_step_setPassword">
      <FormTitle className="form-title_password-form">
        Придумайте и установите пароль
      </FormTitle>
      <Flex column justify="center" align="flex-start">
        <LoginWrapper mb="20px">
          <FieldLabel className="LoginLabel">
            <FieldLabelText>Логин</FieldLabelText>
          </FieldLabel>
          <LoginValueBox className="LoginValue">
            <LoginValue>{fields.login.value}</LoginValue>
          </LoginValueBox>
        </LoginWrapper>
        <Flex column align="flex-start">
          <PasswordFirstWrapper>
            <InputWrapper>
              <FormInput
                width="400px"
                label="Пароль"
                id="password1"
                inputType="password"
                {...getFieldProps('password')}
              />
            </InputWrapper>
            <PasswordDemandsWrapper>
              <Button
                type="text"
                onClick={showHint}
                {...getActionProps({
                  actionId: 'passwordHint'
                })}
              >
                Требования к паролю
              </Button>
            </PasswordDemandsWrapper>
          </PasswordFirstWrapper>
          <InputWrapper>
            <FormInput
              label="Еще раз"
              labelParams={{ whiteSpace: 'nowrap' }}
              width="400px"
              id="password2"
              inputType="password"
              {...getFieldProps('password2')}
            />
          </InputWrapper>
          <ChooseRegionWrapper>
            <ChooseRegionBackground />
            <ChooseRegionTitleWrapper className="CheckOfficeTitle">
              <Text font="caption" size="13px" lineHeight="11px">
                Выберите офис обслуживания
              </Text>
            </ChooseRegionTitleWrapper>
            <InputWrapper>
                <FieldLabel top="38px">
                  <FieldLabelText className="RegionLabelText">Регион</FieldLabelText>
                </FieldLabel>
                <NotTransparentBackgroundWrapper>
                  <FormDropdown
                    items={fields.region.items.map(item => ({
                      label: item.values[0],
                      value: item.id
                    }))}
                    width="400px"
                    {...getFieldProps('region')}
                  />
                </NotTransparentBackgroundWrapper>
            </InputWrapper>
            <InputWrapper>
                <FieldLabel top="96px">
                  <FieldLabelText className="OfficeLabelText">Офис</FieldLabelText>
                </FieldLabel>
                <NotTransparentBackgroundWrapper>
                  <FormDropdown
                    items={fields.branch.items.map(item => ({
                      label: item.values[0],
                      value: item.id
                    }))}
                    width="400px"
                    {...getFieldProps('branch')}
                  />
                </NotTransparentBackgroundWrapper>
            </InputWrapper>
          </ChooseRegionWrapper>
          <Button
            size="large"
            font="caption"
            onClick={handleSubmit(saveForm)}
            bold
            {...getActionProps({ actionId: 'next' })}
          >
            Далее
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

PasswordForm.propTypes = {
  getFieldProps: PropTypes.func.isRequired,
  getActionProps: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  applyAction: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired
};

export default withForm(PasswordForm);



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/PasswordForm/PasswordForm.js